<template>
    <div class="baggage-info">
        <div class="baggage-info-inner">
            <h4 class="baggage-info-title" v-if="title">
                <Icon :type="icon" size="s" /> {{ title }}
            </h4>
            <p class="baggage-info-description" v-if="description">
                {{ description }}
            </p>
        </div>
        <slot />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'Info',
        components: { Icon },
        props: {
            title: { type: String },
            description: { type: String },
            icon: { type: String as PropType<IconType>, default: '' },
        },
    });
</script>
